const get_nearest_ways_code = (lat, lon, distance) => {
    return `[out:json];
    way['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around:${distance},${lat},${lon});
    out geom;
    `
}
const get_way_nodes_code = (municipality, street) => {

    const street_alternatives = street.join('|')

    return `[out:json];
        area['name' = 'Cuba']['admin_level' = 2]->.country;
        area['name' = '${municipality}']['admin_level'='6']->.municipality;
        
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name' ~ '^(${street_alternatives})$']->.street;
        
        (
            .street;
              >;
        );
        
        out geom;
    `
}

const get_ways_by_municipality_code = (municipality) => {
    return `[out:json];
        area['name' = 'Cuba']['admin_level' = 2]->.country;
        area['name' = '${municipality}']['admin_level'='6']->.municipality;
        (
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'];
        );
        
        out geom;
    `
}

const get_first_between_ways_by_main_way_code = (main, municipality) => {
    const main_alternatives = main.join('|')
    
    return `[out:json];
        area['name' = 'Cuba']['admin_level' = 2]->.country;
        area['name' = '${municipality}']['admin_level'='6']->.municipality;
        
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name' ~ '^(${main_alternatives})$']->.main_street;
        
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name']->.streets;
        
        (
          way.streets['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around.main_street:0);
          -
          .main_street;
        );
        
        out geom;
    `
}

const get_second_between_way_code = (main, first, municipality) => {
    const main_alternatives = main.join('|')
    const first_alternatives = first.join('|')

    return `[out:json];
        area['name' = 'Cuba']['admin_level' = 2]->.country;
        area['name' = '${municipality}']['admin_level'='6']->.municipality;
        
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name' ~ '^(${main_alternatives})$']->.main_street;
        
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name' ~ '^(${first_alternatives})$']->.first_between_street;
        
        way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name']->.streets;
        
        (
          (
            way.streets['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around.main_street:0)(around.first_between_street:150);
            -
            way.streets['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around.first_between_street:0);
          );
          -
          (.main_street;.first_between_street;);
        );
        
        
        out geom;
    `
}

const get_center_of_neighborhood_code = (municipality) => {
    return `[out:json];area['name' = 'Cuba']['admin_level' = 2]->.country;area['name' = '${municipality}']['admin_level'='6']->.municipality;relation(area.municipality)(area.country)['boundary'='administrative'];out center;`
}

const get_coordinate_by_main_street_code = (municipality, main) => {
    const main_alternatives = main.join('|')
    return `[out:json];area['name' = 'Cuba']['admin_level' = 2]->.country;area['name' = '${municipality}']['admin_level'='6']->.municipality;way(area.municipality)(area.country)['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'~'^(${main_alternatives})$'];out center;`
}

const get_full_address_elements_code = (lat, long, main_street_distance) => {
    return `[out:json];
        way['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around:${main_street_distance},${lat},${long})->.main_street;
        
        (
        way['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around:50,${lat},${long})(around.main_street:0);
        -
        .main_street;
        )->.street_50;
        (
        way['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around:100,${lat},${long})(around.main_street:0);
        -
        .main_street;
        )->.street_100;
        (
        way['highway'~'trunk|primary|secondary|tertiary|residential|service']['name'](around:200,${lat},${long})(around.main_street:0);
        -
        .main_street;
        )->.street_200;
        
        is_in(${lat},${long})->.areas;
          
        area['boundary'='administrative']['admin_level'].areas->.loc;
        
        .main_street out count;
        .main_street out geom;
        .street_50 out count;
        .street_50 out geom;
        .street_100 out count;
        .street_100 out geom;
        .street_200 out count;
        .street_200 out geom;
        .loc out count;
        .loc out body;
    `
}

export default {
    get_nearest_ways_code,
    get_ways_by_municipality_code,
    get_second_between_way_code,
    get_center_of_neighborhood_code,
    get_coordinate_by_main_street_code,
    get_full_address_elements_code,
    get_way_nodes_code,
    get_first_between_ways_by_main_way_code
}